import { render, staticRenderFns } from "./OpenPollForm.vue?vue&type=template&id=6f1ea0e0&scoped=true"
import script from "./OpenPollForm.vue?vue&type=script&lang=js"
export * from "./OpenPollForm.vue?vue&type=script&lang=js"
import style0 from "./OpenPollForm.vue?vue&type=style&index=0&id=6f1ea0e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1ea0e0",
  null
  
)

export default component.exports